angular.module('siter.io').controller 'SiteSettingsModal', ["$scope", "$state", "$rootScope", "$modalInstance", "$cookies", "Restangular", "FileUploader", "Site", "$modalStack", "Page", "Notification", "$filter", "Email", "WebForm", "Lesson", ($scope, $state, $rootScope, $modalInstance, $cookies, Restangular, FileUploader, Site, $modalStack, Page, Notification, $filter, Email, WebForm, Lesson) ->

  if window.Editor.mode is "site.page.editor"
    $scope.currentSettings = 'fonts'
  else
    $scope.currentSettings = 'bg'

  $scope.site.tags = []
  $scope.isSuperAdminRole = $rootScope.currentUser.role in ["superadmin"]

  if $scope.isSuperAdminRole
    Restangular.all('/templates/tags').getList().then (items) ->
      $scope.items = _.map items, (item, index) -> {text: item, id: index}

  $scope.loadTags = (query) ->
    Restangular.all("/templates/tags?q=#{query}").getList()

  tagsToString = (tags) ->
    tags = _.map tags, (tag) -> tag.text
    return tags.join(",")

  # Apply to template in editor

  applyStyleToTemplate = (site) ->
    $rootScope.$broadcast "get:styles"

  # Update uploaded previews images

  updatePreviews = ->
    d = new Date();
    $(".etn__preview-favicon__image").each ->
      oldattr = $(this).attr("ng-src")
      if oldattr
        $(this).attr("src", "#{oldattr}?"+d.getTime());
    $(".etn__preview-image").each ->
      oldattr = $(this).attr("ng-src")
      if oldattr
        $(this).attr("src", "#{oldattr}?"+d.getTime());

  # Favicon uploader
  $scope.faviconUploader = new FileUploader(
    url: Restangular.configuration.baseUrl+"/sites/#{$state.params.siteId}"
    autoUpload: true
    method: "PUT"
    alias: "favicon"
    headers : {
      'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
    }
  )

  $scope.faviconUploader.onAfterAddingFile = (item) ->
    types = ["image/jpeg", "image/png"]
    if item.file.type not in types
      alert("The file must be png or jpg")
      return false

  $scope.faviconUploader.onSuccessItem = (fileItem, response, status, headers) ->
    $scope.faviconUploader.clearQueue()
    $rootScope.site.favicon = response.favicon
    updatePreviews()
    return

  $scope.faviconUploader.onErrorItem = (fileItem, response, status, headers) ->
    return


  if Editor.mode is "email.page.editor"
    previewUploadUrl = "/emails/" + $state.params.emailId
  else if Editor.mode is "form.page.editor"
    previewUploadUrl = "/web_forms/" + $state.params.formId
  else if Editor.mode is "lesson.page.editor"
    previewUploadUrl = "/lms_pages/" + $state.params.lessonId
  else
    previewUploadUrl = "/sites/" + $state.params.siteId

  # Preview web uploader
  $scope.webPreviewUploader = new FileUploader(
    url: Restangular.configuration.baseUrl+previewUploadUrl
    autoUpload: true
    method: "PUT"
    alias: "preview"
    headers : {
      'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
    }
  )

  $scope.webPreviewUploader.onAfterAddingFile = (item) ->
    types = ["image/jpeg", "image/png"]
    if item.file.type not in types
      alert("The file must be png or jpg")
      return false

  $scope.webPreviewUploader.onSuccessItem = (fileItem, response, status, headers) ->
    $scope.webPreviewUploader.clearQueue()
    $rootScope.site.preview.thumb = response.preview.preview.thumb.url
    updatePreviews()
    return

  $scope.webPreviewUploader.onErrorItem = (fileItem, response, status, headers) ->
    return

  $scope.mobilePreviewUploader = new FileUploader(
    url: Restangular.configuration.baseUrl+previewUploadUrl
    autoUpload: true
    method: "PUT"
    alias: "mobile_preview"
    headers : {
      'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
    }
  )


  # Networking uploader

  $scope.networkingUploader = new FileUploader(
    url: Restangular.configuration.baseUrl+"/sites/#{$state.params.siteId}/pages/#{$scope.currentPage.id}"
    autoUpload: true
    method: "PUT"
    alias: "networking_image"
    headers : {
      'X-AUTH-TOKEN': Restangular.defaultHeaders['X-AUTH-TOKEN']
    }
  )

  updatePreviews = ->
    d = new Date();
    $("#networkingImage").each ->
      oldattr = $(this).attr("ng-src")
      if oldattr
        $(this).attr("src", "#{oldattr}?"+d.getTime());

  $scope.networkingUploader.onAfterAddingFile = (item) ->
    types = ["image/jpeg", "image/png"]
    if item.file.type not in types
      alert("The file must be png or jpg")
      return false

  $scope.networkingUploader.onSuccessItem = (fileItem, response, status, headers) ->
    $scope.networkingUploader.clearQueue()
    $scope.currentPage.networking_image = response.networking_image
    updatePreviews()
    return

  $scope.networkingUploader.onErrorItem = (fileItem, response, status, headers) ->
    return

  $scope.removeNetworkingImage = ->
    Page.remove_networking_image($scope.currentPage.id).then (response) ->
      $scope.currentPage.networking_image = response.networking_image


  # Preview mobile uploader

  $scope.mobilePreviewUploader.onAfterAddingFile = (item) ->
    types = ["image/jpeg", "image/png"]
    if item.file.type not in types
      alert("The file must be png or jpg")
      return false

  $scope.mobilePreviewUploader.onSuccessItem = (fileItem, response, status, headers) ->
    $scope.mobilePreviewUploader.clearQueue()
    $rootScope.site.mobile_preview.thumb = response.mobile_preview.mobile_preview.thumb.url
    updatePreviews()
    return

  $scope.mobilePreviewUploader.onErrorItem = (fileItem, response, status, headers) ->
    return


  $scope.saveSite = (site, siteSettingsForm, fromFavorite = false) ->
    return false if siteSettingsForm.$invalid
    if Editor.mode is "email.page.editor"
      object = Email
    else if Editor.mode is "form.page.editor"
      object = WebForm
      site.is_template = true
    else if Editor.mode is "lesson.page.editor"
      object = Lesson
    else
      object = Site

    site = angular.copy site
    $scope.savingSite = true
    if fromFavorite and $rootScope.currentUser.role in ["admin"]
      site.disabled = true
      site.tags = $filter('translate')('dashboard.myTemplates')

    object.update(site).then ->
      $scope.savingSite = false
      applyStyleToTemplate site
      $scope.close()
      return
    , ->
      $scope.savingSite = false

  $scope.createTemplate = (site, siteSettingsForm, needRedirect = false) ->
    return false if siteSettingsForm.$invalid
    $scope.savingSite = true
    if Editor.mode is "email.page.editor"
      object = Email
    else if Editor.mode is "form.page.editor"
      object = WebForm
    else if Editor.mode is "lesson.page.editor"
      object = Lesson
    else
      object = Site

    templateParams = {
        name: site.name,
        description: site.description,
        preview: site.preview,
        mobile_preview: site.mobile_preview,
        is_manual_preview: site.is_manual_preview,
        tags: tagsToString(site.tags)
    };

    object.createTemplate(templateParams).then (response) ->
      $scope.savingSite = false
      $scope.close()

      if response.status
        if needRedirect

          if object is Email
            redirectUrl = '/sites/constructor/email_template/edit/' + window.justclick.contentType + '#/emails/' + response.slug + '/home/editor'
          else if object is Lesson
            redirectUrl = '/sites/constructor/lesson_template/edit#/lms_pages/' + response.slug + '/home/editor'
          else
            redirectUrl = '/sites/constructor/template/edit#/sites/' + response.slug + '/home/editor'

          window.location.href = redirectUrl

        messageParts = [
          $filter('translate')('template.template'),
          site.name,
          $filter('translate')('template.createSuccessful')
        ]

        Notification.success message: messageParts.join(' ')
      else
        Notification.error message: $filter('translate')('site.error')

      return
    , ->
      $scope.savingSite = false

  $scope.favoriteSaveSettings = (site, siteSettingsForm, needRedirect = false) ->
    if (site.is_template)
      $scope.saveSite(site, siteSettingsForm, true)
    else
      $scope.createTemplate(site, siteSettingsForm, needRedirect)

  $scope.saveHomePage = (page, pageSettingsForm) ->
    return false if pageSettingsForm.$invalid
    $scope.savingPage = true
    Page.update(page).then (newPageData) ->
      page.background_attributes = newPageData.background_attributes
      $scope.savingPage = false
      $scope.close()
    , ->
      $scope.savingPage = false

  $scope.getDesktopPreview = ->
    if $rootScope.site.preview.thumb?
      $rootScope.site.preview.thumb
    else
      $rootScope.site.preview.preview.thumb.url

  $scope.getMobilePreview = ->
    if $rootScope.site.mobile_preview.thumb?
      $rootScope.site.mobile_preview.thumb
    else
      $rootScope.site.mobile_preview.mobile_preview.thumb.url

  $scope.closeAll = ->
    $modalStack.dismissAll 'cancel'


  # Close settings

  $scope.close = ->
    $modalInstance.dismiss "close"

]



// WEBPACK FOOTER //
// ./src/app/site/site_settings/site_settings.controller.coffee